import DotIndicator from './dot-indicator';
export default DotIndicator;
